import { parse, format, isValid } from "date-fns";

export const REGION_ORDER = ["Central", "Northern", "Southern", "East Malaysia"];

export const REGION_STYLE = {
  Central: { banner: "#EFA23B", tint: "#FCEBD0", text: "#7A4E00" },
  Northern: { banner: "#8FBF7A", tint: "#E7F0DF", text: "#2F5122" },
  Southern: { banner: "#8EA9DB", tint: "#E3EAF7", text: "#213A6B" },
  "East Malaysia": { banner: "#E07A7A", tint: "#F8E2E2", text: "#7A1F1F" },
};

export const fmtRM = (v) => {
  const n = Number(v || 0);
  return "RM" + n.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtNum = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  if (isNaN(n)) return String(v);
  return String(n);
};

const DATE_PARSE_FORMATS = ["d MMMM yyyy", "d MMM yyyy", "d MMMM yy", "d MMM yy", "yyyy-MM-dd", "d/MM/yyyy", "d/MM/yy"];

export const shortDate = (v) => {
  if (!v || typeof v !== "string") return v || "";
  for (const fmt of DATE_PARSE_FORMATS) {
    const d = parse(v.trim(), fmt, new Date());
    if (isValid(d)) return format(d, "d MMM yyyy");
  }
  return v;
};

export const displayCell = (col, rec, report) => {
  if (col.computed && col.key === report.row_total_field) {
    const t = (report.sum_fields || []).reduce((s, f) => s + (Number(rec[f]) || 0), 0);
    return t ? fmtNum(t) : "";
  }
  const v = rec[col.key];
  if (Array.isArray(v)) return v.length ? v.join("\n") : "";
  if (col.is_date && report.short_date) return shortDate(v);
  if (col.type === "amount") return v === "" || v == null ? "" : fmtRM(v);
  if (col.type === "number") return fmtNum(v);
  return v == null ? "" : String(v);
};
